import React from "react";

import { FacebookF, LinkedinF, Svg } from "../svg";

/**
 * Native port of ``cms/blocks/hc-block/hc-block--social-banner.html``.
 *
 * Two ``svg.html`` includes pass ``description`` (truthy -> screenreader span
 * BEFORE the svg), ``title`` (truthy -> ``<title>``) and ``ariaHidden=True``
 * (-> ``aria-hidden="true"`` on the svg). The explicit ``{" "}`` between the
 * link text and the icon preserves the single space the legacy template emitted
 * between the inline text and the include output (JSX strips newline+indent
 * whitespace next to a tag, so it must be explicit).
 */
export const SocialBanner = (): React.JSX.Element => (
    <>
        <a
            className="button banner--apply-now"
            href="https://recruiting.adp.com/srccar/public/RTI.home?c=1124607&d=CorporateCareerSite"
        >
            APPLY NOW
        </a>

        <a
            className="button banner--facebook"
            href="https://www.facebook.com/TempurSealyInternational/"
        >
            OUR FACEBOOK{" "}
            <Svg
                Icon={FacebookF}
                src="facebook-f"
                description="Facebook"
                title="Tempur-pedic Facebook"
                ariaHidden={true}
            />
        </a>

        <a
            className="button banner--linkedin"
            href="https://www.linkedin.com/company/tempur-pedic/"
        >
            OUR LINKEDIN{" "}
            <Svg
                Icon={LinkedinF}
                src="linkedin-f"
                description="LinkedIn"
                title="Tempur-pedic LinkedIn"
                ariaHidden={true}
            />
        </a>
    </>
);
